<div class="amazon-container">
    <div class="amazon-header">Check Your Account</div>
        <div class="amazon-description">
        Your subscription should be linked with Samsung Care+
          <p class="pt-30">Please input your email</p>
        </div>


    <form (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)" [formGroup]="detailForm">
        <div class="check-input-wrapper">
                <div class="form_group data_type">
                    <div class="tit">
                        <label for="infoField1">
                            Email <i class="ico_compulsory">*</i>
                        </label>
                    </div>
                    <div class="txt right_gap">
                        <span class="inp_wrap">
                            <input type="text"
                                   id="infoField1"
                                   formControlName="infoField1"
                                   placeholder="Enter your email"
                                   >
                            <span class="focus-border"><i></i></span>
                        </span>
                    </div>
                </div>
          <div class="amazon-button">
            <div class="btn_area">
                <a class="btn btn_type1" [ngClass]="{'disable': !(detailForm.value.infoField1)}"
                   (click)="submitForm($event)">Check User</a>
                <!--      <a class="btn btn_type1" [ngClass]="{'disable': !(form.value.modelCode && form.value.serialNumber)}"-->
                <!--         (click)="onNext()">Continue to select product <img src="./assets/images/button-arrow.png"></a>-->
            </div>
          </div>
        </div>
    </form>
</div>

